/**
 * @generated SignedSource<<d487e21bf3dcc114ca397a7c21d92067>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SectionQueryChords_section$data = {
  readonly chords: ReadonlyArray<{
    readonly definition: {
      readonly bass: string;
      readonly qual: string;
      readonly root: string;
    };
    readonly duration: number;
    readonly id: string;
    readonly notation: ReadonlyArray<string>;
    readonly rhythm: ReadonlyArray<number>;
  }>;
  readonly id: string;
  readonly rhythmUnit: number;
  readonly " $fragmentSpreads": FragmentRefs<"ChordsSimple_section" | "UpdateSectionChordsMutation_section">;
  readonly " $fragmentType": "SectionQueryChords_section";
};
export type SectionQueryChords_section$key = {
  readonly " $data"?: SectionQueryChords_section$data;
  readonly " $fragmentSpreads": FragmentRefs<"SectionQueryChords_section">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SectionQueryChords_section",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rhythmUnit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Chord",
      "kind": "LinkedField",
      "name": "chords",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "duration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rhythm",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ChordDef",
          "kind": "LinkedField",
          "name": "definition",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "root",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "qual",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bass",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notation",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UpdateSectionChordsMutation_section"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChordsSimple_section"
    }
  ],
  "type": "SongSection",
  "abstractKey": null
};
})();

(node as any).hash = "0c3f2b9c30b79963a0265f9bfc54a294";

export default node;
